import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full mb-3">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            观众热评
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自豆花视频用户的真实声音，听听大家怎么说
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-foreground-900">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {comment.time}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 text-foreground-400">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs font-medium">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}